import { LogoUI } from '~/design-system/elements/Logo/LogoUI';
import { cn } from '~/lib/utils';
import themes from './HeaderTheme.module.css';
import styles from './DeckMark.module.css';
import type { HeaderHover, HeaderTheme } from './theme';
import { useV15Theme } from '~/design-system/components/v1_5/theme-context';

export interface DeckMarkProps {
  /** Back to the deck list. */
  onClick?: () => void;
  /** Glyph box. 18px, the header's standard, unless a lane needs otherwise. */
  size?: number;
  theme?: HeaderTheme;
  hover?: HeaderHover;
  /** Stories and visual tests only. */
  forceHover?: boolean;
  className?: string;
}

/**
 * The Deck mark at the far left of the bar: `LogoUI variant="minimal"` in a standard 30x30 slot.
 * The logo paints a literal colour rather than `currentColor`, so the theme picks black or white
 * here instead of mapping a token.
 */
export function DeckMark({
  onClick,
  size = 18,
  theme: themeProp,
  hover = 'shape',
  forceHover = false,
  className,
}: DeckMarkProps) {
  const theme = useV15Theme(themeProp);
  return (
    <button
      type="button"
      className={cn(
        themes[theme],
        styles.mark,
        hover === 'tone' && styles.tone,
        hover === 'shape' && styles.shape,
        forceHover && styles.forceHover,
        className,
      )}
      aria-label="All decks"
      title="All decks"
      onClick={onClick}
    >
      <span className={styles.glyph}>
        <LogoUI variant="minimal" size={size} color={theme === 'dark' ? 'white' : 'black'} />
      </span>
    </button>
  );
}
